export default "__VITE_PUBLIC_ASSET__282d2455__"